import { useState } from "react";
import { USAGE_PRESETS, presetRange, rangeProblem, todayUtc } from "../../helpers/usageRange";

// value: { preset, startDate, endDate }, the period that is applied. Same choices as the
// customer dashboard. The presets apply at once; the custom dates are only a draft until
// "Apply" is pressed, so the API is asked once, with a period that is complete and valid.
const UsageRangeFilter = ({ value, onChange }) => {
  const [customOpen, setCustomOpen] = useState(value.preset === "custom");
  const [draft, setDraft] = useState({ startDate: value.startDate, endDate: value.endDate });
  const problem = customOpen ? rangeProblem(draft) : "";
  const active = customOpen ? "custom" : value.preset;

  const pick = (next) => {
    if (next === "custom") {
      setDraft({ startDate: value.startDate, endDate: value.endDate });
      setCustomOpen(true);
      return;
    }
    setCustomOpen(false);
    onChange({ preset: next, ...presetRange(next) });
  };

  const reset = () => {
    setCustomOpen(false);
    onChange({ preset: "today", ...presetRange("today") });
  };

  return (
    <div className="usage-range">
      <div className="segmented" role="group" aria-label="Usage period">
        {USAGE_PRESETS.map(({ value: val, label }) => (
          <button
            key={val}
            type="button"
            className={`segmented-item ${active === val ? "segmented-item-active" : ""}`}
            aria-pressed={active === val}
            onClick={() => pick(val)}
          >
            {label}
          </button>
        ))}
      </div>
      {customOpen && (
        <form
          className="usage-range-custom"
          onSubmit={(e) => {
            e.preventDefault();
            if (!problem) onChange({ preset: "custom", ...draft });
          }}
        >
          <label>
            From
            <input
              type="date"
              className="form-control primary-form-control"
              value={draft.startDate}
              max={draft.endDate || todayUtc()}
              onChange={(e) => setDraft({ ...draft, startDate: e.target.value })}
            />
          </label>
          <label>
            To
            <input
              type="date"
              className="form-control primary-form-control"
              value={draft.endDate}
              min={draft.startDate}
              max={todayUtc()}
              onChange={(e) => setDraft({ ...draft, endDate: e.target.value })}
            />
          </label>
          <div className="usage-range-actions">
            {/* takes the place of the "From"/"To" captions so the buttons sit level with the inputs */}
            <span aria-hidden="true">&nbsp;</span>
            <div className="usage-range-buttons">
              <button type="submit" className="btn btn-primary" disabled={Boolean(problem)}>
                Apply
              </button>
              <button type="button" className="btn btn-outline-secondary" onClick={reset}>
                Reset
              </button>
            </div>
          </div>
          {problem && <p className="usage-range-error">{problem}</p>}
        </form>
      )}
    </div>
  );
};

export default UsageRangeFilter;
